module.exports = __webpack_public_path__ + "img/red-packet-late.d38dd779.png";